"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZuoraPaymentMethodSchema = void 0;
exports.ZuoraPaymentMethodSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        paymentMethodId: {
            type: 'string',
            minLength: 1
        },
        accountId: {
            type: 'string',
            minLength: 1
        },
        isBusiness: {
            type: 'boolean',
            minLength: 1
        }
    },
    required: [
        'paymentMethodId',
        'accountId'
    ],
    type: 'object'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoienVvcmEtcGF5bWVudC1tZXRob2QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZG9tcy9zY2hlbWFzL3p1b3JhL3p1b3JhLXBheW1lbnQtbWV0aG9kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsT0FBTyxFQUFFLHlDQUF5QztJQUNsRCxVQUFVLEVBQUU7UUFDVixlQUFlLEVBQUU7WUFDZixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxTQUFTLEVBQUU7WUFDVCxJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxVQUFVLEVBQUU7WUFDVixJQUFJLEVBQUUsU0FBUztZQUNmLFNBQVMsRUFBRSxDQUFDO1NBQ2I7S0FDRjtJQUNELFFBQVEsRUFBRTtRQUNSLGlCQUFpQjtRQUNqQixXQUFXO0tBQ1o7SUFDRCxJQUFJLEVBQUUsUUFBUTtDQUNmLENBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgWnVvcmFQYXltZW50TWV0aG9kU2NoZW1hID0ge1xuICAkc2NoZW1hOiAnaHR0cDovL2pzb24tc2NoZW1hLm9yZy9kcmFmdC0wNy9zY2hlbWEjJyxcbiAgcHJvcGVydGllczoge1xuICAgIHBheW1lbnRNZXRob2RJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDFcbiAgICB9LFxuICAgIGFjY291bnRJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDFcbiAgICB9LFxuICAgIGlzQnVzaW5lc3M6IHtcbiAgICAgIHR5cGU6ICdib29sZWFuJyxcbiAgICAgIG1pbkxlbmd0aDogMVxuICAgIH1cbiAgfSxcbiAgcmVxdWlyZWQ6IFtcbiAgICAncGF5bWVudE1ldGhvZElkJyxcbiAgICAnYWNjb3VudElkJ1xuICBdLFxuICB0eXBlOiAnb2JqZWN0J1xufVxuIl19